import React from 'react';
import { Tabs, Tab } from '@mui/material';

const SendingTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Tabs
      value={value}
      indicatorColor='primary'
      textColor='primary'
      onChange={handleChange}
      aria-label='disabled tabs example'
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {['Kommande', 'Avslutade'].map((item) => {
        return <Tab label={item} key={item} />;
      })}
    </Tabs>
  );
};

export default SendingTabs;
